/**
 * Skicka med ett stort unitinfo objekt med parametrar från båda kalkylerna
 */

export enum MultislopeScreenTypes {
  SM = 'SM',
}

export interface ScreeningMediaInterface {
  model?: string;
  description?: string;
  material?: string;
  type?: string;
  function?: string;
  separationSize?: SeparationSizeInterface;
  maxFeedSize?: MaxFeedSizeInterface;
}

export interface SeparationSizeInterface {
  metric: string;
  imperial: string;
}

export interface MaxFeedSizeInterface {
  metric: string;
  imperial: string;
}

/**
 * Efficiency måste vara ett objekt
 */
export interface DeckInterface {
  separationSize: number;
  apertureRatio: number;
  screeningMedia: ScreeningMediaInterface;
  screeningElement: ScreeningMediaInterface;
  openArea: number;
  particleShape: string;
  efficiency: { name: string; value: string };
  efficiencyNumber?: number;
  typeOfApplication: { name: string; value: string };
  sprayBar: boolean;
  display: {
    separationSize: boolean;
    apertureRatio: boolean;
    model: boolean;
    openArea: boolean;
    particleShape: boolean;
    efficiency: boolean;
    description: boolean;
    material: boolean;
    type: boolean;
    function: boolean;
    sprayBar: boolean;
    typeOfApplication: boolean;
  };
}

export interface MultislopeScreenDeckMapInterface {
  0: DeckInterface;
  1: DeckInterface;
}
